
import axios from "./themeInstance"
import { toast } from "react-toastify"
export default async (themeId:string,historyId:string) => {
  
  try {
    const response: any = await axios.put(`/themes/${themeId}/histories/${historyId}/revert`);
    return response.data
  } catch (error) {
    return null
  }
}
